// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});

// Gorgias Chat Integration
// Function to wait for Gorgias chat to be ready and then open it
function waitForGorgiasAndOpenChat() {
  if (typeof GorgiasChat !== "undefined" && GorgiasChat.open) {
    GorgiasChat.open();
  } else {
    setTimeout(waitForGorgiasAndOpenChat, 200); // Keep checking every 200ms until Gorgias is ready
  }
}

// Initialize Gorgias chat functionality when DOM is loaded
document.addEventListener("DOMContentLoaded", function() {
  // Check if URL has #open-chat hash and open chat
  if (window.location.hash === "#open-chat") {
    window.location.hash = ""; // Clear the hash to avoid scrolling issues
    waitForGorgiasAndOpenChat();
  }

  // Add click event listeners to all links with #open-chat
  document.querySelectorAll('a[href="/#open-chat"], a[href="#open-chat"], a[href*="#open-chat"]').forEach(link => {
    link.addEventListener("click", function(event) {
      event.preventDefault();
      waitForGorgiasAndOpenChat();
    });
  });
});

// Also handle dynamic content that might be added after page load
// This is useful for single-page applications or dynamically loaded content
function initializeGorgiasChatLinks() {
  document.querySelectorAll('a[href="/#open-chat"], a[href="#open-chat"], a[href*="#open-chat"]').forEach(link => {
    // Only add listener if it doesn't already have one
    if (!link.hasAttribute('data-gorgias-initialized')) {
      link.setAttribute('data-gorgias-initialized', 'true');
      link.addEventListener("click", function(event) {
        event.preventDefault();
        waitForGorgiasAndOpenChat();
      });
    }
  });
}

// Re-initialize links periodically to catch dynamically added content
setInterval(initializeGorgiasChatLinks, 2000);
